import axios, { AxiosResponse } from "axios";
import { backendApi } from "../../../common/apiService";

export async function get_definitions(token: string, word: string,language?:string) {
	try {
        let url = `/definitions?word=${encodeURIComponent(word)}`;
        if (language) {
            url += `&language=${encodeURIComponent(language)}`;
        }

        const response: AxiosResponse = await backendApi.get(
            url,
            { headers: { Authorization: `Bearer ${token}` }}
        );
		if (response.status === 200) {
            console.log("[get_definitions]Got definitions succesfully:", response.status);
			return response.data;
		} else {
			console.error("[get_definitions]Unexpected error:", response.status);
			return false
		}
	} catch (error) {
		// Handle errors
		if (axios.isAxiosError(error)) {
			console.error("[get_definitions]Error creating definitions:", error.response?.data || error.message);
			return false
		} else {
			console.error("[get_definitions]Unexpected error:", error);
		}
	}
}
